import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class MetadataService {
    constructor(
        private meta: Meta,
        private titleService: Title,
        private environmentService: EnvironmentService,
        @Inject(DOCUMENT) private document: Document
    ) {}

    setColor(colorCode) {
        this.meta.updateTag({ name: 'theme-color', content: colorCode });
    }

    setTitle(pageTitle: string, postfix = '') {
        const title = `${pageTitle}${postfix}`;
        this.titleService.setTitle(title);
        this.setAttribute({ property: 'og:title', content: title });
    }

    setAttribute(data: MetaDefinition) {
        this.meta.updateTag(data);
    }

    setCanonicalUrl(route: string) {
        const linkElement = this.document.getElementById('canonicalUrl');
        const url = `${this.environmentService.hostName()}${route}`;
        linkElement.setAttribute('href', url);
        this.setAttribute({ property: 'og:url', content: url });
    }
}
